import { Component, OnInit, Input } from '@angular/core';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {
    constructor(private dataService: DataService) { }

    ngOnInit() {
    }

    onEvent(event) {
       event.stopPropagation();
    }

    procediConfirm(){
        this.dataService.confirmResponse = true;
        this.dataService.closeConfirm();
    }

    annullaConfirm(){
        this.dataService.confirmResponse = false;
        this.dataService.closeConfirm();
    }

    closeConfirm(){
        this.dataService.closeConfirm();
    }
}
